module.exports = __webpack_public_path__ + "static/media/delete-image.4ece0f6b.svg";